/** HubSpot record identity, mirrored by the extension URL minimizer. */
export interface HubSpotRecord {
  object: 'contact' | 'company';
  portalId: string;
  recordId: string;
}

export const hubspotRecordFromUrl = (url: string): HubSpotRecord | null => {
  try {
    const parsed = new URL(url);
    if (
      parsed.protocol !== 'https:' ||
      parsed.hostname !== 'app.hubspot.com' ||
      parsed.username ||
      parsed.password ||
      parsed.port
    )
      return null;
    const current =
      /^\/contacts\/([1-9][0-9]{0,19})\/record\/(0-1|0-2)\/([1-9][0-9]{0,19})\/?$/.exec(
        parsed.pathname
      );
    if (current)
      return {
        object: current[2] === '0-1' ? 'contact' : 'company',
        portalId: current[1],
        recordId: current[3],
      };
    const legacy =
      /^\/contacts\/([1-9][0-9]{0,19})\/contact\/([1-9][0-9]{0,19})\/?$/.exec(
        parsed.pathname
      );
    return legacy
      ? { object: 'contact', portalId: legacy[1], recordId: legacy[2] }
      : null;
  } catch {
    return null;
  }
};

export const hubspotRecordPath = (record: HubSpotRecord): string =>
  `/contacts/${record.portalId}/record/${record.object === 'contact' ? '0-1' : '0-2'}/${record.recordId}`;
